export const SCENARIOS = [
  { key: "conservative", label: "Conservatief", note: "Snelle verkoopwaarde + hogere reserves" },
  { key: "base", label: "Basisscenario", note: "Verwachte marktwaarde + normale aannames" },
  { key: "upside", label: "Upside", note: "Optimistische verkoopwaarde + normale aannames" },
];

export const VALUE_ROWS = [
  ["Snelle verkoopwaarde", "quick_sale_value", "conservative"],
  ["Verwachte marktwaarde", "expected_market_value", "base"],
  ["Optimistische verkoopwaarde", "optimistic_value", "upside"],
];

export const OVERRIDE_FIELDS = [
  ["transport", "Transport"],
  ["registration_admin", "RDW / administratie"],
  ["inspection_reserve", "Keuring / reconditionering"],
  ["warranty_reserve", "Garantiereserve"],
  ["sales_preparation", "Verkoopklaar maken"],
  ["contingency", "Onvoorzien"],
];

export const inputCls =
  "h-8 w-full rounded-sm border border-slate-300 bg-white px-2 text-[12px] outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200";
